import { render, staticRenderFns } from "./AbsenceReport.vue?vue&type=template&id=c6b7dbfa"
import script from "./AbsenceReport.vue?vue&type=script&lang=js"
export * from "./AbsenceReport.vue?vue&type=script&lang=js"
import style0 from "./AbsenceReport.vue?vue&type=style&index=0&id=c6b7dbfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports